import {SET_STEPS_GROUP_MODE} from 'constants/action-types.js';
import {SET_TRANSFORMATION_EDGE_DRAGGING} from 'constants/action-types.js';

let initialState = {
    stepsGroupMode: false,
    transformationEdgeDragging: undefined,
};

const groupsReducer = (state = initialState, action) => {
    switch (action.type) {
    case SET_STEPS_GROUP_MODE:
        return {
            ... state,
            stepsGroupMode: action.payload
        };
    case SET_TRANSFORMATION_EDGE_DRAGGING:
        return {
            ... state,
            transformationEdgeDragging: action.payload
        };
    default:
        return state;
    }
}

export default groupsReducer;
